import { useAuthStore } from '@/stores/auth'
import { redirectToAuth } from '@/utils/authRedirect'

export function useAuthRedirect() {
	const authStore = useAuthStore()

	function ensureAuthenticated(): Promise<void> {
		return new Promise<void>((resolve, reject) => {
			if (!authStore.isAuthenticated) {
				// В internal-режиме редиректа нет — пропускаем действие дальше,
				// доступ определяет бэк.
				if (redirectToAuth()) {
					reject(new Error('Not authenticated'))
				} else {
					resolve()
				}
			} else {
				resolve()
			}
		})
	}

	return { ensureAuthenticated }
}
